import React, { Component } from 'react'
import Panel from '@common/Panel'
import List from './List'
import style from './style.module.less'
import TimeCount from '@common/TimeCount'
import { inject, observer } from 'mobx-react'

@inject('store')
@observer
export default class extends Component {
  render() {
    const { taskPageData } = this.props.store
    const { endAt, newTask, undoneCount } = taskPageData || {}
    return (
      <Panel
        title="新手任务"
        extra={
          <>
            {endAt && (
              <TimeCount endTime={endAt} onEnd={window.location.reload}>
                {(days, hours, minutes, seconds) => {
                  return (
                    <div className={style.timeCount}>
                      完成任务倒计时：
                      <div className={style.time}>
                        <div>{days}</div>
                        <div>天</div>
                        <div>{hours}</div>:
                        <div>{minutes}</div>:
                        <div>{seconds}</div>
                      </div>
                    </div>
                  )
                }}
              </TimeCount>
            )}
            {undoneCount !== 0 &&
              !!newTask &&
              !endAt && (
                <div className={style.text}>任务审核通过后即可开通流量扶持</div>
              )}
            {undoneCount === 0 && (
              <div className={style.text}>恭喜你已完成全部任务</div>
            )}
          </>
        }
        style={{ flex: 1, marginBottom: 0 }}
      >
        <List />
      </Panel>
    )
  }
}
